"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
class UpdateManaProgressProcessing {
    constructor(sourceId, teamId, num, reason = index_1.Reasons.NOTHING) {
        this.sourceId = sourceId;
        this.teamId = teamId;
        this.num = num;
    }
}
exports.UpdateManaProgressProcessing = UpdateManaProgressProcessing;
function updateManaProgreassProcessor(battle, data, _) {
    // TODO: 追月神用的事件
    const mana = battle.manas[data.teamId];
    if (!mana)
        return 0;
    // battle.log(mana);
    // battle.log(data);
    mana.progress = mana.progress + data.num;
    if (mana.progress < 0)
        mana.progress = 0;
    if (mana.progress > 5)
        mana.progress = 5;
    return -1;
}
exports.default = updateManaProgreassProcessor;
